'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ComposerToolbar } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatComposerUtilityClasses } from "./chatComposerClasses.mjs";
import { mergeSlotProps } from "../internals/mergeSlotProps.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatComposerToolbar');
const ChatComposerToolbarStyled = styled('div', {
  name: 'MuiChatComposer',
  slot: 'Toolbar',
  overridesResolver: (_, styles) => styles.toolbar
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(0.5)
}));
const ChatComposerToolbar = /*#__PURE__*/React.forwardRef(function ChatComposerToolbar(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatComposerToolbar'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatComposerUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ComposerToolbar, _extends({
    ref: ref
  }, other, {
    slots: _extends({}, slots, {
      toolbar: slots?.toolbar ?? ChatComposerToolbarStyled
    }),
    slotProps: _extends({}, slotProps, {
      toolbar: mergeSlotProps({
        className: clsx(classes.toolbar, className),
        sx
      }, slotProps?.toolbar)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatComposerToolbar.displayName = "ChatComposerToolbar";
process.env.NODE_ENV !== "production" ? ChatComposerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatComposerToolbar };